import template from './template.html';

function Directive() {
  return {
    restrict: 'E',
    replace: true,
    template,
    scope: {
      inventory: '=',
      venue: '=',
      onBack: '='
    },
    controller: [
      '$scope',
      '$sce',
      '$rootScope',
      'jsSdk.config',
      ($scope, $sce, $rootScope, jsSdkConfig) => {
        if (!$scope.inventory) throw new Error('inventory');
        if (!$scope.venue) throw new Error('venue');

        $scope.inventoryForm = {
          inventoryQuantity: 1
        };

        $scope.getBookingUrl = function() {
          const checkoutUrl = `${window.location.origin}/buy`;

          const quantity = $scope.inventoryForm.inventoryQuantity || 1;

          let url = `${checkoutUrl}?inventory=${$scope.inventory.id}&quantity=${quantity}`;

          if ($rootScope.affiliateId) {
            url += `&affiliateId=${$rootScope.affiliateId}`;
          }

          if ($rootScope.trackingId) {
            url += `&trackingId=${$rootScope.trackingId}`;
          }

          if (jsSdkConfig.attributionId) {
            url += `&attributionId=${jsSdkConfig.attributionId}`;
          }

          url += '&client=web';

          $scope.bookingUrl = $sce.trustAsResourceUrl(url);
        };

        $scope.inventoryDescription = $sce.trustAsHtml($scope.inventory.description);

        $scope.getTicketSelectorQuantity = function() {
          if (!$scope.inventory) return [];

          const min = $scope.inventory.quantityMin || 0;
          const max = $scope.inventory.quantityMax || 10;

          const quantities = [];

          for (let i = min; i <= max; i++) { //eslint-disable-line
            quantities.push(i);
          }

          return quantities;
        };

        $scope.back = function($event) {
          if ($event) $event.preventDefault();

          if ($scope.onBack) {
            $scope.onBack();
          }
        };

        $scope.bookingFormSubmitted = function() {
          $scope.submittingBookingForm = true;
        };

        $scope.getBookingUrl();
      }
    ]
  };
}

Directive.$inject = [];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/selectedInventory/index.js